import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Quadrant from './Quadrant';
import Tooth from './Tooth';
import type { ToothState } from './AddServices.types';

interface ToothQuadrantProps {
  onSurfaceClick: (num: number | string, surface: string) => void;
  tooth_select: boolean | ToothState;
  onToothClick: (num: number | string) => void;
  num: number | string;
  toothPositionTop?: boolean;
}

const ToothContainer = styled(Stack)({
  flexWrap: 'wrap',
  alignItems: 'center',
  width: 70,
});

function ToothQuadrant({
  onSurfaceClick,
  tooth_select: toothSelect,
  onToothClick,
  num,
  toothPositionTop = false,
}: ToothQuadrantProps) {
  if (toothPositionTop) {
    return (
      <ToothContainer>
        <Tooth num={num} onToothClick={onToothClick} tooth_select={toothSelect} />
        <Quadrant num={num} onSurfaceClick={onSurfaceClick} tooth_select={toothSelect} />
      </ToothContainer>
    );
  }

  return (
    <ToothContainer>
      <Quadrant num={num} onSurfaceClick={onSurfaceClick} tooth_select={toothSelect} />
      <Tooth num={num} onToothClick={onToothClick} tooth_select={toothSelect} />
    </ToothContainer>
  );
}

export default ToothQuadrant;
